import { useState, useRef } from 'react';
import XTable from 'components/XTable';
import { Modal, Input, notification, Switch, Space } from 'antd';
import { getAuthListApi, putAuthDetailApi } from 'api/authV1';
import XForm from 'components/XForm';

const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};

const ApiMGT = () => {
    const xTableRef = useRef();
    const xFormRef = useRef();
    const [modalVisible, setmodalVisible] = useState(false);
    const [okBtnLoading, setokBtnLoading] = useState(false);
    const [id, setid] = useState('');

    const showModal = (data = {}) => {
        const { isCheck, path = '', method = '', name = '', id = '', isLogin } = data;
        setid(id);
        setmodalVisible(true);
        setTimeout(() => {
            xFormRef.current.form?.setFieldsValue({
                isCheck,
                path,
                method,
                name,
                isLogin,
            });
        }, 0);
    };

    // 弹窗确认
    const handelOk = () => {
        xFormRef.current.form?.submit();
    };

    // 弹窗取消
    const handelCancel = () => {
        setmodalVisible(false);
        setid('');
        xFormRef.current.form?.setFieldsValue({
            isCheck: true,
            path: '',
            method: '',
            name: '',
            isLogin: true,
        });
    };

    // 执行新增|修改接口
    const onFinish = values => {
        setokBtnLoading(true);
        const { isCheck, isLogin, name } = values;
        const params = { isCheck, isLogin, name, id };
        putAuthDetailApi(params).then(res => {
            if (res.success) {
                notification.success({
                    message: `接口修改成功。`,
                });
                setmodalVisible(false);
                xTableRef.current.refreshTable && xTableRef.current.refreshTable();
            }
            setokBtnLoading(false);
        });
    };

    const columns = [
        {
            title: '接口名称',
            dataIndex: 'name',
        },
        {
            title: '接口路径',
            dataIndex: 'path',
        },
        {
            title: '请求方式',
            dataIndex: 'method',
        },
        {
            title: '是否需要校验',
            dataIndex: 'isCheck',
            render: val => {
                return val ? '是' : '否';
            },
        },
        {
            title: '是否需要登录',
            dataIndex: 'isLogin',
            render: val => {
                return val ? '是' : '否';
            },
        },
        {
            title: '操作',
            dataIndex: '',
            render: (val, data) => {
                return (
                    <Space size="middle">
                        <span className="actionText" onClick={() => showModal(data)}>
                            修改
                        </span>
                    </Space>
                );
            },
        },
    ];
    const formItems = [
        {
            formItemApis: {
                label: '接口名称',
                name: 'name',
                rules: [{ required: true }],
            },
            item: <Input />,
        },
        {
            formItemApis: {
                label: '接口路径',
                name: 'path',
                rules: [{ required: true }],
            },
            item: <Input disabled />,
        },
        {
            formItemApis: {
                label: '请求方式',
                name: 'method',
                rules: [{ required: true }],
            },
            item: <Input disabled />,
        },
        {
            formItemApis: {
                label: '是否需要校验',
                name: 'isCheck',
                valuePropName: 'checked',
                rules: [{ required: true }],
            },
            item: <Switch checkedChildren="是" unCheckedChildren="否" />,
        },
        {
            formItemApis: {
                label: '是否需要登录',
                name: 'isLogin',
                valuePropName: 'checked',
                rules: [{ required: true }],
            },
            item: <Switch checkedChildren="是" unCheckedChildren="否" />,
        },
    ];
    return (
        <div>
            <XTable columns={columns} api={getAuthListApi} rowKey="id" ref={xTableRef} />
            <Modal
                title="修改接口"
                centered
                visible={modalVisible}
                onOk={handelOk}
                okButtonProps={{ loading: okBtnLoading }}
                onCancel={handelCancel}>
                <XForm
                    formApis={{
                        ...formTailLayout,
                        name: 'adminAction',
                        onFinish: onFinish,
                    }}
                    formItems={formItems}
                    ref={xFormRef}
                />
            </Modal>
        </div>
    );
};
export default ApiMGT;
